import { render, staticRenderFns } from "./MdTitle.vue?vue&type=template&id=1f30dca5&"
import script from "./MdTitle.vue?vue&type=script&lang=js&"
export * from "./MdTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports